import Services from '../../common/Services'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const Bonuses = ({ services, title, label }) => {
  const { isTablet } = useResponsive()

  return (
    <Section variant={['gray', 'o-hidden']}>
      <Container>
        <Columns>
          <Column spans={isTablet ? 12 : 6}>
            {label && <span className={styles.intro}>{label}</span>}

            {title && <h2 className={styles.title}>{title}</h2>}
          </Column>
        </Columns>
      </Container>

      <Services services={services} />
    </Section>
  )
}

export default Bonuses
